import React, { forwardRef } from 'react';

import classNames from 'classnames';

import { NavigationLink, NavigationLinkProps } from '../navigation/NavigationLink';

import './NavigationDropDownLink.scss';

const NavigationDropDownLink = forwardRef<HTMLAnchorElement, NavigationLinkProps>(({ className, ...props }, ref) => {
    return <NavigationLink {...props} ref={ref} className={classNames('nav-dropdown-link', className)} />;
});

export default NavigationDropDownLink;
